/**
 * Session-replay block list shared by both recorders (PostHog + Sentry) so their configs can't drift.
 * Both record via rrweb, whose node mirror retains every node it has seen (detached included) and
 * walks into the same-origin TV iframe — recording the chart/order-book mutation firehose grew the
 * production heap ~500kB/s. Block, don't mask: masked nodes still enter the mirror.
 */

/** Put this on the root of any high-mutation subtree that should never be recorded. */
export const REPLAY_BLOCK_CLASS = 'replay-no-record';

/** Matches `CandleSticksContainer`'s default `containerId`. */
const CHART_CONTAINER_SELECTOR = '#tv_chart_container';

/** Sentry's `replayIntegration({ block })` takes an array of selectors. */
export const REPLAY_BLOCK_SELECTORS = [CHART_CONTAINER_SELECTOR, `.${REPLAY_BLOCK_CLASS}`];

/** PostHog's `session_recording.blockSelector` takes one comma-joined selector string. */
export const REPLAY_BLOCK_SELECTOR = REPLAY_BLOCK_SELECTORS.join(', ');
